module.exports = "<p>\n  smart-booking-segment works!\n</p>\n"